import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  api as authApi,
  PublicUserProfile,
  Token,
  TokenResponse,
} from '@app/services/auto-generated/auth'
import { RootState } from '@app/store'
import { LOGOUT, setAccessToken, setTokens, setUser, waitForRehydration } from './auth-actions'

interface authState {
  user: PublicUserProfile | null
  tokens: TokenResponse | null
  userToVerify: null | { email: string }
  firstTime: null | boolean
  firstTimeHuddle: null | boolean
}

const initialState: authState = {
  user: null,
  tokens: null,
  userToVerify: null,
  firstTime: true,
  firstTimeHuddle: true,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserToVerify: (state, { payload }) => {
      state.userToVerify = payload
    },
    setUserFirstTime: (state, { payload }) => {
      state.firstTime = payload
    },
    setUserFirstTimeHuddle: (state, { payload }) => {
      state.firstTimeHuddle = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(waitForRehydration.fulfilled, () => {})
      .addCase(setUser, (state, action: PayloadAction<PublicUserProfile>) => {
        state.user = action.payload
      })
      .addCase(setTokens, (state, action: PayloadAction<TokenResponse>) => {
        state.tokens = action.payload
      })
      .addCase(setAccessToken, (state, action: PayloadAction<Token | null>) => {
        if (state.tokens) {
          state.tokens.access_token = action.payload
        } else {
          state.tokens = { access_token: action.payload }
        }
      })
      .addCase(LOGOUT, () => {
        return { ...initialState, firstTime: false, firstTimeHuddle: false }
      })
      .addMatcher(authApi.endpoints.authWhoami.matchFulfilled, (state, { payload }) => {
        state.user = payload
      })
      .addMatcher(authApi.endpoints.authLogin.matchFulfilled, (state, { payload }) => {
        state.tokens = payload
      })
      .addMatcher(authApi.endpoints.authLoginGoogle.matchFulfilled, (state, { payload }) => {
        state.tokens = payload
      })
      .addMatcher(authApi.endpoints.authRegisterEmail.matchFulfilled, (state, { payload }) => {
        state.tokens = payload
      })
  },
})

export default authSlice.reducer

export const { setUserToVerify, setUserFirstTime, setUserFirstTimeHuddle } = authSlice.actions

export const selectUser = (state: RootState) => state.auth.user
export const selectTokens = (state: RootState) => state.auth.tokens
export const selectUserToVerify = (state: RootState) => state.auth.userToVerify
export const selectUserFirstTime = (state: RootState) => state.auth.firstTime
